export const Video = {
  iso_639_1: "",
  iso_3166_1: "",
  name: "",
  key: "",
  site: "",
  size: 0,
  type: "",
  official: false,
  published_at: "",
  id: "",
};

export const Videos = {
  results: [],
};
